import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {ChartModule} from 'angular-highcharts';
import {MATERIAL} from './util/material.modules';
import {FlexLayoutModule} from '@angular/flex-layout';
import {SWIPER_CONFIG, SwiperConfigInterface, SwiperModule} from 'ngx-swiper-wrapper';
import {ApiHttpService} from '@rsp/shared/services/rest/api-http.service';
import {RspEndpointsService} from '@rsp/shared/services/rest/rsp-endpoints.service';
import {CommunityActivityChartComponent} from '@rsp/shared/component/graph/impl/community-activity-chart.component';
import {CommunityAutarkieGradChartComponent} from '@rsp/shared/component/graph/impl/community-autarkie-grad-chart.component';
import {CommunityErzeugungVerbrauchChartComponent} from '@rsp/shared/component/graph/impl/community-erzeugung-verbrauch-chart.component';
import {StrombilanzAutarkieGradChartComponent} from '@rsp/shared/component/graph/impl/strombilanz-autarkie-grad-chart.component';
import {StrombilanzEnergieStroemeChartComponent} from '@rsp/shared/component/graph/impl/strombilanz-energie-stroeme-chart.component';
import {BaseChartComponent} from '@rsp/shared/component/graph/base-chart.component';
import {DateSelectionComponent} from '@rsp/shared/component/date-selection/date-selection.component';
import {CarouselComponent} from '@rsp/shared/component/carousel/carousel.component';
import {MapComponent} from '@rsp/shared/component/map/map.component';
import {LoadingWrapperComponent} from '@rsp/shared/component/loading-wrapper/loading-wrapper.component';
import {AdaptedDecimalPipe} from '@rsp/shared/pipes/adapted-decimal.pipe';
import {LeaveComponentGuard} from '@rsp/shared/guards/LeaveComponentGuard';
import {CustomPreloadingStrategy} from '@rsp/shared/preload/custom-preloading.strategy';
import {FileUploadModule} from 'primeng/fileupload';

import {SafeUrlPipe} from '@rsp/shared/pipes/safe-url.pipe';
import {CropperDialogComponent} from '@rsp/shared/dialog/cropper/cropper-dialog.component';
import {ImageUploaderComponent} from '@rsp/shared/component/image-uploader/image-uploader.component';
import {DefaultImageDirective} from '@rsp/shared/directive/default-image.directive';
import {MatDialogModule} from '@angular/material/dialog';
import {NotificationComponent} from '@rsp/shared/component/notification/notification.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {KennzahlComponent} from '@rsp/shared/component/kennzahl/kennzahl.component';
import {DateToStringPipe} from '@rsp/shared/pipes/date-to-string.pipe';
import {UserTrackingService} from '@rsp/shared/services/user-tracking.service';
import {environment} from '@env/environment';
import {UserTrackingServiceNoop} from '@rsp/shared/services/user-tracking.service.noop';


const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};


@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    ...MATERIAL,
    ChartModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    SwiperModule,
    FileUploadModule,
    MatDialogModule,
    MatTooltipModule
  ],
  providers: [
    ApiHttpService,
    RspEndpointsService,
    {
      provide: UserTrackingService,
      useClass: environment.matomoTrackUser ? UserTrackingService : UserTrackingServiceNoop
    }
  ],
  declarations: [
    // Charts
    BaseChartComponent,
    CommunityAutarkieGradChartComponent,
    CommunityErzeugungVerbrauchChartComponent,
    StrombilanzAutarkieGradChartComponent,
    StrombilanzEnergieStroemeChartComponent,
    CommunityActivityChartComponent,

    // Components
    DateSelectionComponent,
    CarouselComponent,
    MapComponent,
    LoadingWrapperComponent,
    ImageUploaderComponent,
    NotificationComponent,
    KennzahlComponent,

    // Pipes
    AdaptedDecimalPipe,
    DateToStringPipe,
    SafeUrlPipe,

    // Dialog
    CropperDialogComponent,

    // Directive
    DefaultImageDirective


  ],
  exports: [
    ...MATERIAL,
    BaseChartComponent,
    CommunityAutarkieGradChartComponent,
    CommunityErzeugungVerbrauchChartComponent,
    StrombilanzAutarkieGradChartComponent,
    StrombilanzEnergieStroemeChartComponent,
    CommunityActivityChartComponent,

    DateSelectionComponent,
    CarouselComponent,
    MapComponent,
    LoadingWrapperComponent,
    CropperDialogComponent,
    ImageUploaderComponent,
    NotificationComponent,
    KennzahlComponent,
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      providers: [
        LeaveComponentGuard,
        CustomPreloadingStrategy,
        {provide: SWIPER_CONFIG, useValue: DEFAULT_SWIPER_CONFIG}],
      ngModule: SharedModule
    };
  }
}
